export enum TournamentType {
  Score = 1, // Tournament where users can collect score and win based their score
  Bet, // Tournament where they participate in the tournament by placing real bets and can win different prizes
}